import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';

// please sync reaction styles that are not button-specific with ReactionButton.tsx
var staticReactionStyles = xcss({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  minWidth: '36px',
  height: '24px',
  backgroundColor: 'color.background.neutral.subtle',
  color: 'color.text.subtle',
  marginBlockStart: 'space.050',
  marginInlineEnd: 'space.050',
  padding: 'space.0',
  overflow: 'hidden',
  border: 'none',
  borderRadius: 'border.radius',
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered',
    cursor: 'default'
  }
});
export var StaticReaction = function StaticReaction(_ref) {
  var onMouseEnter = _ref.onMouseEnter,
    onFocus = _ref.onFocus,
    children = _ref.children,
    testId = _ref.testId,
    _ref$dataAttributes = _ref.dataAttributes,
    dataAttributes = _ref$dataAttributes === void 0 ? {} : _ref$dataAttributes;
  return jsx(Box, _extends({
    onMouseEnter: onMouseEnter,
    onFocus: onFocus,
    testId: testId,
    xcss: staticReactionStyles
  }, dataAttributes), children);
};